import React, {useEffect } from 'react';
import {useDispatch, useSelector} from "react-redux";
import {NavLink, useNavigate, useLocation} from "react-router-dom";
import MediaFooter from "../../Components/MediaFooter";
import WelcomeLeft from "./Welcome/WelcomeLeft";
import WelcomeRight from "./Welcome/WelcomeRight";
import SignUpRight from "./Signup/SignUpRight"
import SignUpLeft from "./Signup/SignUpLeft";

import {decrementLoginStep,setLoginStep} from "../../../Features/Misc/loginSlice";
import {reset} from "../../../Features/Auth/authSlice";
import {fetchCustomers} from "../../../Features/Auth/authSlice";
import {setLogin, setSignUp} from "../../../Features/Misc/loginSlice";

export default function SignupLogin(props) {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const {pathname} = useLocation()

    useEffect(() => {
        // Check if the pathname includes '/login' or '/signup'
        if (pathname === "/login") {
            dispatch(setLoginStep(1));
            dispatch(setLogin());
        } else if (pathname === "/signmeup") {
            dispatch(setLoginStep(1));
            dispatch(setSignUp());
        }

    }, [pathname, dispatch]);


    // useEffect(() => {
    //     dispatch(fetchCustomers());
    // }, []);


    useEffect(() => {
        dispatch(fetchCustomers());
    }, [dispatch]);

    //redux state
    const { loginStep } = useSelector((state) => state.login)
    const {user, isSuccess} = useSelector((state) => state.auth)


    const logoPositioning = (loginStep === 0
        ? " hidden cursor-pointer row-start-2 row-end-2 col-start-1 col-end-13 flex justify-center items-center lg:block "
        : " hidden cursor-pointer row-start-2 row-end-2 col-start-1 col-end-13 flex justify-center items-center lg:block"
    )

    const logoStatus = (loginStep === 0
        ? "hidden"
        : "flex"
    )

    // useEffect(() =>{
    //     if(isSuccess){
    //
    //     }
    //
    //     if(user){
    //         navigate("/")
    //     }
    //
    //     return () =>{
    //         dispatch(reset())
    //     }
    // },[user])
    useEffect(() =>{
        if(isSuccess){

        }

        if(user){
            navigate("/")
        }

        return () =>{
            dispatch(reset())
        }
    },[user, navigate, dispatch, isSuccess])


    return (

        <div className="signupLogin grid grid-cols-12 grid-rows-12 ">
            {!user && <>
                <div className="left bg-purple-dashboard row-start-1 row-end-13 lg:row-end-13 col-start-1 col-end-13 lg:col-end-7 h-screen lg:h-max ">
                    <div className="left bg-purple-dashboard lg:bg-purple-slumber w-full h-full lg:rounded-br-thicc lg:grid lg:grid-cols-12 lg:grid-rows-12 z-0" >
                    <div className=" left-inner row-start-1 row-end-13 col-start-1 col-end-13 z-10 bg-cover grid grid-cols-12 grid-rows-12" style={{backgroundImage: `url("https://www.kipmate.com/sortyourkip/client/build/Group_4580.png")` }} />
                        <div className={`mt-4 mx-4 row-start-2 row-end-3 col-start-3 col-end-11 lg:hidden ${logoStatus} justify-between items-center`}>
                            <div onClick={() => dispatch(decrementLoginStep())} className={`flex gap-3  items-center z-20 `}>
                                <i className="ri-arrow-left-line text-gold-accent text-2xl cursor-pointer"></i>
                                <div className={`text-white text-xl cursor-pointer`}>Back</div>
                            </div>
                            <img className="w-32" src="https://www.kipmate.com/sortyourkip/client/build/kmlogo.svg" alt=""/>
                        </div>

                        <div className={` left-inner row-start-2 lg:row-start-1 row-end-13 lg:row-end-12 col-start-1 col-end-13 lg:col-start-3   z-20 text-white   lg:grid lg:grid-cols-12 lg:grid-rows-12 `}>
                            <NavLink className={` ${logoPositioning} `} to={"/"}>
                                <img className="w-32" src="https://www.kipmate.com/sortyourkip/client/build/kmlogo.svg" alt=""/>
                            </NavLink>

                                {loginStep === 0 ? <WelcomeLeft /> : <SignUpLeft />}

                        </div>
                </div>
            </div>


                <div className="right bg-purple-slumber h-0 lg:row-start-1 lg:row-end-13 lg:col-start-7 lg:col-end-13 lg:h-full ">
                    <div className="right bg-purple-dashboard hidden w-full h-full rounded-tl-thicc lg:grid grid-cols-12 grid-rows-12 ">
                    <div className="right-inner  row-start-1 row-end-13 col-start-1 col-end-13 grid grid-cols-12 grid-rows-12">
                        <div className=" row-start-2 row-end-13 col-start-4 col-end-13  text-white " />
                        {loginStep === 0 &&
                            <>
                                <div className="right-inner row-start-2 lg:row-start-1 row-end-12 lg:row-end-13 col-start-4 col-end-10  justify-between text-white grid grid-cols-12 grid-rows-12 ">
                                <WelcomeRight />
                            </div>

                            <MediaFooter className={`flex justify-center items-end col-start-5 col-end-9 px-6 row-start-12 lg:row-start-11 row-end-13 lg:row-end-12 `}/>
                            </>
                        }

                        {(loginStep !== 0) &&
                            <>
                                <SignUpRight/>
                                {(loginStep !== 5) &&
                                    < MediaFooter className={`flex justify-center items-end col-start-5 col-end-9 px-6 row-start-12 lg:row-start-11 row-end-13 lg:row-end-12 `}/>
                                }

                            </>
                        }

                    </div>
                </div>
            </div>
            </>}
        </div>
    );
}